import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICountriesArray, IStepTwo, TError } from './types/StepTwo-inerface';
import { fetchCountries, fetchDaDataAddres } from './action/fetch-step-two';

const initialState: IStepTwo = {
    Insurer: {
        LastName: '',
        FirstName: '',
        MiddleName: '',
        BirthDate: '',
        Gender: '',
        Address: '',
        CountryID: '',
        Phone: '',
        Email: '',
        DocumentDate: '',
        DocumentDepartment: '',
        DepartmentCode: '',
        DocumentNumber: '',
        DocumentSeries: ''
    },
    Insureds: [
        {
            LastName: '',
            FirstName: '',
            MiddleName: '',
            BirthDate: '',
            Gender: '',
            Address: '',
            CountryID: '',
            Phone: '',
            Email: '',
            DocumentDate: '',
            DocumentDepartment: '',
            DepartmentCode: '',
            DocumentNumber: '',
            DocumentSeries: ''
        }
    ],
    RegionID: '',
    CalculationRequestID: '',
    Programs: [],
    BeginDate: '',
    EndDate: '',
    PolicyholderIsSame: true,
    Countries: {
        isLoadingCountries: false,
        errorCountries: [],
        Countries: []
    },
    DaDataAddres: {
        isLoadingDaDataAddres: false,
        errorDaDataAddres: [],
        Suggestions: []
    }
};

export const StepTwoSlice = createSlice({
    name: 'StepTwoSlice',
    initialState,
    reducers: {
        updateField: (state, action: PayloadAction<{ field: keyof IStepTwo; value: IStepTwo[keyof IStepTwo] }>) => {
            const { field, value } = action.payload;
            state[field] = value as never;
        },
        resetForm: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountries.pending, (state) => {
                state.Countries.isLoadingCountries = true;
            })
            .addCase(fetchCountries.fulfilled, (state, action: PayloadAction<{ Countries: ICountriesArray[] }>) => {
                state.Countries.Countries = action.payload.Countries;
                state.Countries.isLoadingCountries = false;
                state.Countries.errorCountries = [];
            })
            .addCase(fetchCountries.rejected, (state, action) => {
                state.Countries.Countries = initialState.Countries.Countries;
                state.Countries.isLoadingCountries = false;
                state.Countries.errorCountries = action.payload as TError;
            })
            .addCase(fetchDaDataAddres.pending, (state) => {
                state.DaDataAddres.isLoadingDaDataAddres = true;
            })
            .addCase(fetchDaDataAddres.fulfilled, (state, action: PayloadAction<{ Suggestions: string[] }>) => {
                state.DaDataAddres.Suggestions = action.payload.Suggestions;
                state.DaDataAddres.isLoadingDaDataAddres = false;
                state.DaDataAddres.errorDaDataAddres = [];
            })
            .addCase(fetchDaDataAddres.rejected, (state, action) => {
                state.DaDataAddres.Suggestions = initialState.DaDataAddres.Suggestions;
                state.DaDataAddres.isLoadingDaDataAddres = false;
                state.DaDataAddres.errorDaDataAddres = action.payload as TError;
            })
    },
});

export const { updateField } = StepTwoSlice.actions;
export default StepTwoSlice.reducer;


